<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-start justify-center pt-10 bg-black bg-opacity-50 sm:items-center sm:pt-0"
    @click="handleClickOutside"
  >
    <div class="w-full max-w-4xl p-6 bg-white rounded-lg" @click.stop>
      <h4 class="mb-4 text-xl font-bold">{{ title }}</h4>
      <InputLabel for="role" value="Role Akses" class="mb-2" />
      <select
        name="role"
        v-model="form.role_id"
        class="block w-full py-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
      >
        <option value="0" selected>Role</option>
        <option v-for="role in roles" :key="role.id" :value="role.id">
          {{ role.title }}
        </option>
      </select>
      <InputError :message="form.errors.role_id" class="mt-2" />
      <InputLabel for="role" value="Users" class="mt-2" />
      <v-select
        v-model="form.user_id"
        multiple
        :reduce="(user) => user.id"
        :options="users"
        label="name"
        class="block w-full py-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
      ></v-select>
      <InputError :message="form.errors.user_id" class="mt-2" />

      <InputLabel for="role" value="Program Studi" class="mt-2" />
      <v-select
        v-model="form.idprodi"
        multiple
        :reduce="(program) => program.kodeprodi"
        :options="programs"
        label="name"
        class="block w-full py-2 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
      ></v-select>
      <InputError :message="form.errors.idprodi" class="mt-2" />

      <div class="flex justify-end space-x-4">
        <button
          @click="submit"
          class="w-full px-4 py-2 font-semibold text-white shadow bold bg-blue hover:bg-blue-700 rounded-xl hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Simpan
        </button>
        <button
          @click="closeModal"
          class="px-4 py-2 mt-4 text-white bg-red-500 rounded"
        >
          Tutup
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import InputLabel from "@/Components/InputLabel.vue";
import InputError from "@/Components/InputError.vue";
import { computed, ref, watch, defineProps, defineEmits } from "vue";
import { useForm } from "@inertiajs/vue3";
import vSelect from "vue-select";

import Swal from "sweetalert2";
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  menuId: {
    type: [Number, String], // Allow both Number and String
    required: true,
  },
  roles: {
    type: Array, // Roles should be an array
    required: true,
  },
  programs: {
    type: Array, // Programs should be an array
    required: true,
  },
  users: {
    type: Array, // Programs should be an array
    required: true,
  },
});

const emit = defineEmits(["update:isOpen"]);

const form = useForm({
  id: null,
  menu_id: props.menuId, // Get menuId from props
  role_id: "", // Use an empty string as the default
  user_id: [],
  idprodi: [], // Use an empty array for multiple selections
});

// Watch for changes in props.menuId
watch(
  () => props.menuId,
  (newMenuId) => {
    form.menu_id = newMenuId;
  }
);
// const roles = ref([]);
// const programs = ref([]);
// Fetch menu role data when modal opens
const fetchMenuRoleData = async () => {
  if (props.isOpen) {
    try {
      const response = await axios.get(`/menuroles/${props.menuId}`);
      if (response.status === 200) {
        const menuRole = response.data.menuroles;
        form.id = menuRole.id;
        form.menu_id = menuRole.menu_id;
        form.role_id = menuRole.role_id;
        form.user_id = menuRole.user_id || [];
        form.idprodi = menuRole.idprodi || []; // Handle multiple program studi

        console.log("Menu role data fetched:", menuRole);
      } else {
        console.error("Menu role not found.");
      }
    } catch (error) {
      console.error("Error fetching menu role data:", error);
    }
  }
};

// Watch for when the modal is opened
watch(
  () => props.isOpen,
  (isOpen) => {
    if (isOpen) {
      fetchMenuRoleData();
    }
  }
);

const submit = () => {
  if (form.id) {
    form.put(route("menuroles.update", form.id), {
      _method: "put", // Add _method for PUT request
      onSuccess: () => {
        form.reset();
        emit("update:isOpen", false); // Close the modal
      },
    });
  } else {
    form.post(route("menuroles.store"), {
      onSuccess: () => {
        form.reset();
        emit("update:isOpen", false);
        Swal.fire({
          title: "Berhasil!",
          text: "Data berhasil disimpan!.",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload();
        });
      },
    });
  }
};

const closeModal = () => {
  emit("update:isOpen", false);
};

const handleClickOutside = (event) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};
</script>
<style scoped></style>
style
